import '../styles/Navbar.css';
import React, { useState } from 'react';

const NAV_ITEMS = [
  { name: 'Landing', href: '/', access: 'Public' },
  { name: 'Login', href: '/login', access: 'Identity access' },
  { name: 'Extraction', href: '/extraction', access: 'Sign in required' },
  { name: 'Leads', href: '/leads', access: 'Sign in required' },
];

function currentPathname() {
  if (typeof window !== 'undefined' && window.location && window.location.pathname) {
    return window.location.pathname;
  }
  return '/';
}

function resolveActivePage(activePage) {
  if (typeof activePage === 'string' && activePage.trim().length > 0) {
    return activePage.trim();
  }
  const path = currentPathname();
  const match = NAV_ITEMS.find((item) => item.href === path);
  return match ? match.name : '';
}

function Navbar({ activePage }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const resolvedActive = resolveActivePage(activePage);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="nb-root" role="banner">
      <div className="nb-inner">
        <a className="nb-wordmark" href="/" aria-label="leads-linkedin home">
          <span className="nb-wordmark-mark" aria-hidden="true" />
          <span className="nb-wordmark-name">leads-linkedin</span>
        </a>

        <div className="nb-actions">
          <a
            className="nb-access"
            href="/login"
            aria-current={resolvedActive === 'Login' ? 'page' : undefined}
          >
            Sign in
          </a>
          <button
            type="button"
            className="nb-toggle"
            aria-expanded={menuOpen}
            aria-controls="nb-menu-panel"
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span className="nb-toggle-bar" aria-hidden="true" />
            <span>Menu</span>
          </button>
        </div>
      </div>

      <nav
        id="nb-menu-panel"
        className="nb-panel"
        aria-label="Product pages"
        hidden={!menuOpen}
      >
        <ul className="nb-list">
          {NAV_ITEMS.map((item) => (
            <li key={item.name}>
              <a
                className="nb-link"
                href={item.href}
                aria-current={resolvedActive === item.name ? 'page' : undefined}
                onClick={closeMenu}
              >
                <span className="nb-link-label">
                  <span className="nb-link-marker" aria-hidden="true" />
                  {item.name}
                </span>
                <span className="nb-link-meta">{item.access}</span>
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
}

export default Navbar;